import { ApolloError, useQuery } from '@apollo/client';

import { popularTemplatesQuery } from './popularTemplatesQuery';

import { PopularTemplatesQuery, SuggestionPersonalization } from '../../types';

export type Service = NonNullable<
  PopularTemplatesQuery['suggestedZapTemplates']['edges'][0]['zapTemplate']
>['services'][0];

type UsePopularTemplatesProps = {
  variables: {
    limit?: number;
    roleCanonicalId?: string;
    personalizeBy?: SuggestionPersonalization;
  };
  skip?: boolean;
};

export type Template = ReturnType<typeof getPopularTemplates>[0];

const getPopularTemplates = (data: PopularTemplatesQuery) =>
  data?.suggestedZapTemplates?.edges?.map(
    ({ zapTemplate }) =>
      zapTemplate && {
        ...zapTemplate,
        url: zapTemplate?.url && `https://zapier.com${zapTemplate.url}`,
      },
  );

export const usePopularTemplates = ({
  variables: { roleCanonicalId, limit, personalizeBy },
  skip,
}: UsePopularTemplatesProps): {
  data: ReturnType<typeof getPopularTemplates>;
  loading: boolean;
  error?: ApolloError;
} => {
  const { data, loading, error } = useQuery(popularTemplatesQuery, {
    variables: {
      roleCanonicalId,
      limit: limit || 3,
      personalizeBy: personalizeBy || SuggestionPersonalization.Role,
    },
    skip,
  });

  return { data: getPopularTemplates(data), loading, error };
};
